import { render, staticRenderFns } from "./ChatBanKeywordPage.vue?vue&type=template&id=407be262&scoped=true"
import script from "./ChatBanKeywordPage.vue?vue&type=script&lang=js"
export * from "./ChatBanKeywordPage.vue?vue&type=script&lang=js"
import style0 from "./ChatBanKeywordPage.vue?vue&type=style&index=0&id=407be262&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "407be262",
  null
  
)

export default component.exports